<div class="layout-wrapper" [ngClass]="containerClass">
    <gt-admin-topbar></gt-admin-topbar>
    <div class="layout-sidebar">
        <gt-admin-sidebar></gt-admin-sidebar>
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
    </div>
    <div class="layout-mask"></div>
</div>
